import { MutationTree } from 'vuex';

const mutations: MutationTree<Store.StarWars.ProtagonistState> = {
  setProtagonist(state, payload: Store.StarWars.Protagonist) {
    state.protagonist = payload;
  },
};

export default mutations;
